import { useState } from "react";
import { environment } from "../environment";
import {
  DocumentType,
  EncodeToBase64,
  ParseDataToCSV,
  RemoveCommaDelimiterInData,
  getDocumentDownloadLinkAndDownload,
  getDocumentTitle,
} from "../utils/export.util";
import { useAxios } from "./useAxios";
import useKeycloakData from "./useKeycloakData";
import { useUserContext } from "../context/user.context";

export const useExport = () => {
  var config = {
    responseType: "arraybuffer",
  };

  const [exportFlag, setExportFlag] = useState(false);

  const { axiosInstance } = useAxios(null, config);
  const { merchantName } = useUserContext();

  const fetchExportDocumentFromBackend = (type, csvData) => {
    const documentTitle = getDocumentTitle(type, merchantName);

    setExportFlag(true);

    //Construct Backend URL
    const paramsString = `exportType=${type.toLowerCase()}&title=${documentTitle}`;
    const url = `${environment.reportingCSVConvert}?${paramsString}`;

    //Convert CSV to BASE64
    const cvsToBase64 = EncodeToBase64(csvData);
    // FETCH BACKEND
    axiosInstance?.current
      ?.put(url, {
        //title: documentTitle,
        //type: type,
        data: cvsToBase64,
      })
      .then((response) => {
        setExportFlag(false);
        getDocumentDownloadLinkAndDownload(response?.data, type, merchantName);
      })
      .catch((err) => {
        setExportFlag(false);
        console.log(err);
      });
  };

  const downloadFile = (documentType, dataToExport = []) => {
    const clearedData = documentType === DocumentType.TEXT ? dataToExport : RemoveCommaDelimiterInData(dataToExport);

    //Convert Data to CSV
    const csvData = documentType === DocumentType.TEXT ? dataToExport : ParseDataToCSV(clearedData);

    //For CSV data NO BACKEND CALL IS NEEDED!!!
    if (documentType === DocumentType.CSV || documentType === DocumentType.TEXT) {
      return getDocumentDownloadLinkAndDownload(csvData, documentType, merchantName);
    }

    //For PDF and EXCEL call BACKEND FIRST!!!
    fetchExportDocumentFromBackend(documentType, csvData);
  };

  return {
    downloadFile,
    exportFlag,
  };
};
